'use client';

import { cn } from '@core/utils';

import { AD_UNIT_IDS, WELLO_IMAGE_PREFIX_URL } from '@/constants';
import type { AdUnitId } from '@/constants/ad';

import { BenefitAdCard } from './BenefitAdCard';
import { BenefitCard } from './BenefitCard';

const EXTERNAL_LINKS = {
  SHINHAN_CARD_EVENT:
    'https://www.shinhancard.com/pconts/html/benefit/event/1238318_2239.html',
  TAX_RETURN:
    'https://mydata.signalplanner.co.kr/insure/mydata/login?is_from=wello_tax_return&flow=mydata_tax_return&desktop=y',
} as const;

const CARD_VARIANTS = {
  kb: {
    backgroundColor: '#EBF8FF',
    title: 'KB국민카드X웰로',
    mainText: '체크카드',
    subText: '발급 혜택',
    src: `${WELLO_IMAGE_PREFIX_URL}/static/home/gold-money.png`,
    href: '/donation/event/kb-check-card',
  },
  shinhan: {
    backgroundColor: '#EBF8FF',
    title: '신한카드X웰로',
    mainText: '카드발급',
    subText: '혜택 받기',
    src: `${WELLO_IMAGE_PREFIX_URL}/static/home/gold-money.png`,
    href: EXTERNAL_LINKS.SHINHAN_CARD_EVENT,
  },
} as const;

interface UpperBenefitBannerProps {
  className?: string;
  /** 광고 유닛 ID (기본값: HOME_NATIVE_BM_TOP) */
  adUnitId?: AdUnitId;
  /** 카드 배너 종류 (기본값: kb) */
  cardVariant?: keyof typeof CARD_VARIANTS;
}

export const UpperBenefitBanner = ({
  className,
  adUnitId = AD_UNIT_IDS.HOME_NATIVE_BM_TOP,
  cardVariant = 'kb',
}: UpperBenefitBannerProps) => {
  const card = CARD_VARIANTS[cardVariant];

  return (
    <section className={cn('px-16', className)}>
      <div className={cn('grid grid-cols-2 gap-12')}>
        <BenefitCard
          backgroundColor={card.backgroundColor}
          title={card.title}
          mainText={card.mainText}
          subText={card.subText}
          src={card.src}
          href={card.href}
        />

        {/* BM 광고 (광고 없을 시 기존 카드 표시) */}
        <BenefitAdCard
          unitId={adUnitId}
          backgroundColor="#F1FFF5"
          fallback={
            <BenefitCard
              backgroundColor="#F1FFF5"
              title="마이데이터로"
              mainText="보험료"
              subText="무료진단받기"
              src={`${WELLO_IMAGE_PREFIX_URL}/static/home/money.png`}
              href={EXTERNAL_LINKS.TAX_RETURN}
            />
          }
        />
      </div>
    </section>
  );
};
